import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { FullScreenLoading } from '@backrs_ui/common-ui';

import { isStructuredSession } from '@backrs_ui/grow-ui/src/models/models';
import { loadOfficeHoursSessionData } from '@backrs_ui/grow-ui/src/redux/coachLubav/coachLubav.thunk';
import { useAppDispatch, useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { setActiveSessionType } from '@backrs_ui/grow-ui/src/redux/lubavSessionState/lubavSessionState';
import { selectShareToken } from '@backrs_ui/grow-ui/src/redux/sharedSession/sharedSession';
import { useGetSharedOfficeHoursSessionDataQuery } from '@backrs_ui/grow-ui/src/redux/sharedSession/sharedSession.api';

import { Box, SxProps, Theme, Typography } from '@mui/material';

export const SharedOfficeHoursPage = () => {
  const dispatch = useAppDispatch();
  const { sessionType } = useParams<{ sessionType: string }>();

  const shareToken = useAppSelector(selectShareToken);
  const sessionTypeId = isStructuredSession(sessionType) ? sessionType : null;
  const isValidSessionType = sessionTypeId !== null;

  const { data, isLoading, error } = useGetSharedOfficeHoursSessionDataQuery(
    { accessToken: shareToken || '' },
    { skip: !shareToken || !isValidSessionType },
  );

  useEffect(() => {
    if (!data || !sessionTypeId) {
      return;
    }

    if (data.session_type !== sessionTypeId) {
      return;
    }

    dispatch(setActiveSessionType(sessionTypeId));
    dispatch(loadOfficeHoursSessionData({ sessionData: data, activeSession: sessionTypeId }));
  }, [data, sessionTypeId, dispatch]);

  if (isLoading || !shareToken) {
    return <FullScreenLoading />;
  }

  if (!isValidSessionType || error || !data) {
    return (
      <Box sx={errorContainerSx}>
        <Typography variant="text-lg-semibold">
          Unable to load shared session. The link may have expired or been revoked.
        </Typography>
      </Box>
    );
  }

  return null;
};

const errorContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  padding: backrs.spacing['spacing-xl'],
  textAlign: 'center',
});
